import React, { Suspense, useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import { Routes } from '../routes'
import ChangeLogView from '../Views/shared/ChangeLogView'
import InstitutionEvaluationView from '../Views/institution/InstitutionEvaluationSummaryView/InstitutionEvaluationView'
import InstitutionGroupProvider from '../Providers/InstitutionGroupProvider'
import SchoolsView from '../Views/institutionGroup/SchoolsView/SchoolsView'
import InstitutionsView from '../Views/institutionGroup/InstitutionsView/InstitutionsView'
import SectorsView from '../Views/institutionGroup/SectorsView/SectorsView'
import InternshipsView from '../Views/institution/InternshipsView/InternshipsView'
import GroupsSettingsView from '../Views/institutionGroup/Settings/GroupsSettingsView'
import { GlobalContext } from '../Providers/GlobalProvider'
import ShiftsManagerView from '../Views/institution/InstitutionShiftManager'
import TagsManagementView from '../Views/shared/TagsManagementView'
import InstitutionFeedbackDrawer from '../Providers/Drawer/InstitutionFeedbackDrawer'
import InstitutionProvider from '../Providers/InstitutionProvider'
import ReportingPage from '../Views/institution/ReportingPage/ReportingPage'

const InstitutionGroupAdminRouter = ({ history }) => {
  const { currentDate, setCurrentDate } = useContext(GlobalContext)

  return (
    <InstitutionGroupProvider>
      <InstitutionProvider>
        <Switch>
          <Route path={Routes.INTERNSHIPS}>
            <InternshipsView loadShiftsManager={setCurrentDate} />
          </Route>
          <Route path={Routes.SHIFTS_MANAGER}>
            <InstitutionFeedbackDrawer>
              <ShiftsManagerView
                currentDate={currentDate}
              />
            </InstitutionFeedbackDrawer>
          </Route>
          <Route path={Routes.SCHOOLS}>
            <SchoolsView />
          </Route>
          <Route path={Routes.INSTITUTIONS}>
            <InstitutionsView />
          </Route>
          <Route path={Routes.INSTITUTION_SECTORS}>
            <SectorsView />
          </Route>
          <Route path={Routes.TAGS_MANAGEMENT}>
            <TagsManagementView />
          </Route>
          <Route path={Routes.SETTINGS}>
            <GroupsSettingsView />
          </Route>
          <Route path={Routes.BADGES}>
            <ReportingPage />
          </Route>
          <Route path={Routes.STUDENTS_EVALUATION}>
            <Suspense fallback={<div>Loading...</div>}>
              <InstitutionEvaluationView />
            </Suspense>
          </Route>
          <Route path={Routes.CHANGELOG}>
            <ChangeLogView />
          </Route>
        </Switch>
      </InstitutionProvider>
    </InstitutionGroupProvider>
  )
}

export default withRouter(InstitutionGroupAdminRouter)
